export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "enginePress.worker.0e1dc251b5066e033b54-854.worker.js");
}
